<template>
  <div>
    <z-header :title="title" :actions="actions"></z-header>
    <div>Processando...</div>
  </div>
</template>

<script>
import ZHeader from "../../layout/Header";
import fleetVehicle from "../../services/fleetVehicle";

export default {
  data() {
    return {
      title: "Remover veículo",
      id: null,
      entry: {},
      isLoading: false,
      actions: []
    };
  },
  mounted() {
    this.id = this.$route.params.id;
    this.remove();
  },
  methods: {
    async remove() {
      try {
        this.entry = await fleetVehicle.get(this.id);

        this.$buefy.dialog.confirm({
          message: `Você confirma a exclusão do veículo <strong>${this.id} - ${this.entry.registrationPlate}</strong>?`,
          onConfirm: async () => {
            await fleetVehicle.delete(this.id);

            this.$router.push({
              name: "fleetVehicle"
            });
          },
          onCancel: async () => {
            this.$router.push({
              name: "fleetVehicle/editar",
              params: { id: this.id }
            });
          }
        });
      } catch (error) {
        this.$buefy.toast.open({
          message: "Erro ao remover os veículo",
          type: "is-danger"
        });
      }
    }
  },
  components: {
    ZHeader
  }
};
</script>

<style lang="scss"></style>
